export const BDXEditFormInjectionKey = 'bdx-edit-form'
